module.exports = __webpack_public_path__ + "static/media/blogbanner.a21b31ef.jpg";